import React from "react"
import { mapMonths } from "../Mappers"
import { PhotoOrganiserItem } from "../Components/CategoryItemContainer"

export const Calendar: React.FunctionComponent<{ item: PhotoOrganiserItem }> = ({ item }) => {
  const month = item.dateFrom ? mapMonths(Number(item.dateFrom.substr(5, 2))).slice(0, 3) : ""
  const day = item.dateFrom ? item.dateFrom.substr(8, 2) : ""
  return (
    <div className="photoselector-calendar-overlay">
      <div className="photoselector-calendar-overlay-month" data-tam="overlay-month">
        {month}
      </div>
      <div className="photoselector-calendar-overlay-day" data-tam="overlay-day">
        {day}
      </div>
    </div>
  )
}
